/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChartIntervalStep } from './chart-interval-step';
import { DateTimePeriod } from './date-time-period';


export interface GetContainerChartRequest { 
    containerId?: string;
    datePeriod?: DateTimePeriod;
    intervalStep?: ChartIntervalStep;
}



